import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NFCrossSellingFormContainer, PropositionContainer } from './styles';
import CommonButton from '../../../../components/common-button/CommonButton';
import { AppDispatch } from '../../../../store.type';
import {
  changeNiumForexScreen,
  setCrossSellingInformationAction
} from '../../../../redux/actions/nium-forex/nium-forex-action';
import { NF_SCREENS } from '../../root/screenConstants';
import { niumForexCrossSellingSelector } from '../../../../redux/selectors';
import { CrossSellingScreenObjectType, logUserEventForNFCrossSelling } from './utils';
import { EventNames } from '../../../../utils/events/eventsConstants';
import { BACK_ARROW_SVG_ICON } from '@Images';

const NFCrossSelling = () => {
  const {
    labels,
    explore: { screens, tabs },
    currentExploreTab
  } = useSelector(niumForexCrossSellingSelector);
  const dispatch = useDispatch<AppDispatch>();

  const handleOnClick = () => {
    logUserEventForNFCrossSelling({
      eventName: EventNames.NF_CROSS_SELLING.explore,
      pageName: 'NF_cross_selling_explore',
      properties: { product: currentExploreTab }
    });
    dispatch(
      setCrossSellingInformationAction({ selectedProducts: [currentExploreTab.toUpperCase()] })
    );
    dispatch(changeNiumForexScreen(NF_SCREENS.cross_selling_form));
  };

  return (
    <NFCrossSellingFormContainer>
      <div className="top-bar-container">
        <img
          alt="back"
          className="back-button"
          src={BACK_ARROW_SVG_ICON}
          width={16}
          height={16}
          onClick={() => dispatch(changeNiumForexScreen(NF_SCREENS.send_money))}
        />

        <div className="top-bar-tabs">
          <div className="tabs-container">
            {tabs.map((tab: { name: string; title: string }) => (
              <span
                className={`tab ${currentExploreTab === tab.name ? 'active' : ''}`}
                key={tab.name}
                onClick={() =>
                  dispatch(setCrossSellingInformationAction({ currentExploreTab: tab.name }))
                }
              >
                {tab.title}
              </span>
            ))}
          </div>
        </div>
      </div>
      <PropositionContainer>
        <div className="props-info-container">
          <div className="graphic-container">
            <span className="__heading">{screens[currentExploreTab].title}</span>
            <span className="__sub-heading">{screens[currentExploreTab].description}</span>
            <div className="cards-container">
              {screens[currentExploreTab].cards.map((card: CrossSellingScreenObjectType) => (
                <div key={card.key} className="card">
                  <img src={card.icon} className="__card-icon" alt={card.title} />
                  <span className="__card-title">{card.title}</span>
                  <span className="__card-description">{card.description}</span>
                </div>
              ))}
            </div>
          </div>
          <CommonButton margin="24px 0 0" width={335} text="Explore" onClick={handleOnClick} />
          <span className="help-text">
            {labels.forexExploreHelpText.desc1}{' '}
            <a
              href={`mailto:${labels.forexExploreHelpText.email}`}
              rel="noopener noreferrer"
              target="_blank"
              className="help-center-link"
            >
              {labels.forexExploreHelpText.email}
            </a>
          </span>
        </div>
      </PropositionContainer>
    </NFCrossSellingFormContainer>
  );
};

export default NFCrossSelling;
